export enum CRMChoice {
  Shopify = 0,
  WooCommerce = 1,
  BigCommerce = 2,
  Konnektive = 3,
  Sticky = 4,
  Magento = 5,
  Opencart = 6,
  WIX = 7,
  SquareSpace = 8,
  SalesforceCommerce = 9,
  ClickFunnels = 10,
  GrooveFunnels = 11,
  YourOwnProprietary = 12,
  Other = 13,
  Admoji = 14,
  Phoenix = 15,
}

export const CRMChoiceLabels = {
  [CRMChoice.Shopify]: 'Shopify',
  [CRMChoice.WooCommerce]: 'WooCommerce',
  [CRMChoice.BigCommerce]: 'Big Commerce',
  [CRMChoice.Konnektive]: 'Konnektive',
  [CRMChoice.Sticky]: 'Sticky.io',
  [CRMChoice.Magento]: 'Magento',
  [CRMChoice.Opencart]: 'Opencart',
  [CRMChoice.WIX]: 'WIX',
  [CRMChoice.SquareSpace]: 'SquareSpace',
  [CRMChoice.SalesforceCommerce]: 'Salesforce Commerce',
  [CRMChoice.ClickFunnels]: 'Click Funnels',
  [CRMChoice.GrooveFunnels]: 'Groove Funnels',
  [CRMChoice.YourOwnProprietary]: 'Your own-Proprietary',
  [CRMChoice.Other]: 'Other',
  [CRMChoice.Admoji]: 'Admoji',
  [CRMChoice.Phoenix]: 'Phoenix',
};

export const CRMChoices = Object.keys(CRMChoiceLabels)
  .map(value => ({value: Number(value), label: CRMChoiceLabels[value]}))
  .sort((a, b) => {
    let result;
    if (a.value === CRMChoice.Other) {
      result = 1;
    } else if (b.value === CRMChoice.Other) {
      result = -1;
    } else {
      result = a.label.localeCompare(b.label);
    }
    return result;
  });

export const SupportTickets = [
  "100 - 999",
  "1,000 - 1,999",
  "2,000 - 4,999",
  "5,000 - 9,999",
  "10,000 - 19,999",
  "20,000+",
]
